import React, { Children } from 'react';
import { AnchorIcon } from 'lucide-react';
export const WhyItMatters = () => {
  return <section className="py-12 sm:py-16 bg-gray-50" data-id="element-227">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <div className="text-center" data-id="element-229">
          <h2 className="text-base text-[#990000] font-semibold tracking-wide uppercase" data-id="element-230">
            Why This Matters Now
          </h2>
          <p className="mt-2 text-2xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-3xl md:text-4xl" data-id="element-231">
            In a world filled with distraction and uncertainty
          </p>
          <p className="mt-4 max-w-2xl text-lg sm:text-xl text-gray-500 mx-auto" data-id="element-232">
            Children need anchors more than ever. This keepsake is more than
            history — it's a blueprint for living with courage and conviction,
            built to inspire your family for generations.
          </p>
        </div>
        <div className="mt-8 sm:mt-10 flex justify-center" data-id="element-233">
          <div className="inline-flex items-center px-4 py-2 border border-transparent text-sm sm:text-base font-medium rounded-md shadow-sm text-white bg-[#0A2463]" data-id="element-234">
            <AnchorIcon className="mr-2 h-4 w-4 sm:h-5 sm:w-5" data-id="element-235" />
            <span data-id="element-236">Because some values are too important not to preserve.</span>
          </div>
        </div>
      </div>
    </section>;
};